<template>
    <div class="order">
        <van-nav-bar
                title="订单明细"
                left-arrow
                :fixed='true'
                @click-left="onClickBack"
            />
        
        <div class="order-search">
            <van-cell :title="'订单:'+search.orderCode" style="color:#25C973;" size="large" />
        </div>
        <div class="order-state">
            <van-steps direction="vertical" :active="0">
                <van-step v-for="(orderState,index) in orderStateList" :key="index">
                    <h3>【{{orderState.description}}】{{orderState.remark}}</h3>
                    <p>{{formatTime(orderState.createTime)}}</p>
                </van-step>
            </van-steps>
        </div>
        
    
  </div>
</template>

<script>
    import {formatTime} from '../../common/functionUtil';
  import {setAesString,getAesString} from "../../config/date";
export default {
    name: 'orderFlow',
    data(){
        return{
            search:{
                orderCode:null,
            },
            orderStateList: [
                // {title:'下单',dremak:'已下单,待支付',createTime:'2019-08-01 11:12:11'}
            ],
            loading: false,
            finished: false,
        }
    },
    created(){
       this.search.orderCode = sessionStorage.getItem(setAesString("orderCode"));
        if(this.search.orderCode == null){
            this.$dialog.alert({
                message: '订单信息获取失败,返回上一步重新操作!'
            }).then(() => {
                //提交数据
                this.$router.push({
                    path:'/aIdx'
                });
            });
            return;
        }
        this.search.orderCode = getAesString(this.search.orderCode);
        this.onSearch();
    },
    methods: {
        formatTime,
        onClickBack() {
            this.$router.back(-1);//返回上一层
        },
        onSearch(){

            var formdata = {
                service:'user.qryChoiceNumberFlow',
                orderCode:this.search.orderCode
            }
            this.orderStateList = [];
            this.$api.post("/mstx/pr/gateway.do", formdata,(res)=>{
               this.orderStateList=res;
            },(res)=>{
                this.$toast.fail(res.errorMsg);
            });
        }
  }
}
</script>

<style lang="less">
//绿rgb(7, 193, 96)
//蓝#20A0FF
.order{
    &-search{
        margin-top: 47px;
        //border-bottom: 1px solid #25C973;

    }
    &-state{
        margin-top: 10px;
    }
}
</style>
